"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var FilterSmall = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 18 18", fill: "currentColor", width: size || "18", height: size || "18" }, props),
        React.createElement("path", { d: "M12,6.5 C12,5.11928813 10.8807119,4 9.5,4 C8.11928813,4 7,5.11928813 7,6.5 C7,7.15597188 7.25264239,7.75293597 7.66593199,8.19889708 C8.11381664,8.35708857 8.51987955,8.60384977 8.86307936,8.91813935 C9.06642542,8.9715546 9.27989082,9 9.5,9 C9.72010918,9 9.93357458,8.9715546 10.1369206,8.91813935 C10.4801205,8.60384977 10.8861834,8.35708857 11.334068,8.19889708 C11.7473576,7.75293597 12,7.15597188 12,6.5 Z M16,11.5 C16,13.4329966 14.4329966,15 12.5,15 C11.2268374,15 10.1124486,14.3202089 9.5,13.3037933 C8.88755143,14.3202089 7.77316257,15 6.5,15 C4.56700338,15 3,13.4329966 3,11.5 C3,9.62111374 4.48050105,8.08801703 6.33855563,8.0036574 C6.12149472,7.54810057 6,7.03823859 6,6.5 C6,4.56700338 7.56700338,3 9.5,3 C11.4329966,3 13,4.56700338 13,6.5 C13,7.03823859 12.8785053,7.54810057 12.6614444,8.0036574 C14.5194989,8.08801703 16,9.62111374 16,11.5 Z M10.665932,9.80110292 C10.2526424,10.247064 10,10.8440281 10,11.5 C10,12.8807119 11.1192881,14 12.5,14 C13.8807119,14 15,12.8807119 15,11.5 C15,10.1192881 13.8807119,9 12.5,9 C12.2798908,9 12.0664254,9.0284454 11.8630794,9.08186065 C11.5198795,9.39615023 11.1138166,9.64291143 10.665932,9.80110292 Z M7.13692064,9.08186065 C6.93357458,9.0284454 6.72010918,9 6.5,9 C5.11928813,9 4,10.1192881 4,11.5 C4,12.8807119 5.11928813,14 6.5,14 C7.88071187,14 9,12.8807119 9,11.5 C9,10.8440281 8.74735761,10.247064 8.33406801,9.80110292 C7.88618336,9.64291143 7.48012045,9.39615023 7.13692064,9.08186065 Z" })));
};
FilterSmall.displayName = 'FilterSmall';
exports.default = FilterSmall;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=FilterSmall.js.map